import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {flex: 1},

      flatList: {
        flex: 1,
        backgroundColor: props.colors.white,
        marginBottom: 30,
        marginTop: 20,
        borderWidth: 1,
        borderColor: props.colors.extraLight,
        borderRadius: 12,
      },

      item: {
        width: '100%',
        height: 64,
        flexDirection: 'row',
        paddingHorizontal: 32,
        backgroundColor: props.colors.dirtyWhite,
        borderRadius: 12,
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden',
      },

      evenItem: {
        backgroundColor: props.colors.white,
      },

      textContainer: {
        flex: 1,
        height: 64,
        alignItems: 'flex-start',
        justifyContent: 'center',
      },

      textStyle: {
        fontSize: 16,
        ...props.typography.interRegular,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {},
    },
  )();
